import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi';

import { images } from '../../constants';
import './Footer.css';

const Footer = () => (
  <div className="app__footer section__padding" id="login">
    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">Jl. Samanhudi No.49-51, Pasar Baru. Jakarta Pusat. 10710</p>
        <p className="p__opensans">+62 819-2022-4155</p>
        <p className="p__opensans">clippercraft@gmail.com</p>
      </div>

      <div className="app__footer-links_logo">
      <h1 className="headtext__cormorant">ClipperCraft</h1>
        <p className="p__opensans">&quot;Cara terbaik untuk menemukan Gaya Rambut Proporsional Anda.&quot;</p>
        <img src={images.line} className="line__img" style={{ marginTop: 15 }} alt="spoon"/>
        <div className="app__footer-links_icons">
          <FiFacebook />
          <FiTwitter />
          <FiInstagram />
        </div>
      </div>

      
    </div>

    <div className="footer__copyright">
      <p className="p__opensans">@2024 ClipperCraft. All Rights reserved.</p>
    </div>

  </div>
);

export default Footer;